export const navModalContent = {
    vehicles: {
        mainItems: [
            {
                label: "Model S",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Vehicles-Model-S.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/models"
                    },
                    {
                        label: "Order",
                        link: "https://www.tesla.com/models/design"
                    }
                ]
            },
            {
                label: "Model 3",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Vehicles-Model-3-LHD.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/model3"
                    },
                    {
                        label: "Order",
                        link: "https://www.tesla.com/model3/design"
                    }
                ]
            },
            {
                label: "Model X",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Vehicles-Model-X.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/modelx"
                    },
                    {
                        label: "Order",
                        link: "https://www.tesla.com/modelx/design"
                    }
                ]
            },
            {
                label: "Model Y",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Vehicles-Model-Y.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/modely"
                    }, 
                    {
                        label: "Order",
                        link: "https://www.tesla.com/modely/design"
                    }
                ]
            },
            {
                label: "Cybertruck",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Vehicles-Cybertruck-1x.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/cybertruck"
                    },
                    {
                        label: "Order",
                        link: "https://www.tesla.com/cybertruck/design"
                    }
                ]
            },
            {
                label: "Help Me Choose",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Vehicles-HMC-RedBlue-LHD.png",
                links: [
                    {
                        label: "Get Started",
                        link: "https://www.tesla.com/choose"
                    }
                ]
            }
        ],
        sideItems: [
            {
                label: "Inventory",
                link: "https://www.tesla.com/new"
            },
            {
                label: "Used Cars",
                link: "https://www.tesla.com/used"
            },
            {
                label: "Demo Drive",
                link: "https://www.tesla.com/drive"
            },
            {
                label: "Trade-in",
                link: "https://www.tesla.com/tradein"
            },
            {
                label: "Compare",
                link: "https://www.tesla.com/compare"
            },
            {
                label: "Help Me Charge",
                link: "https://www.tesla.com/charge"
            },
            {
                label: "Fleet",
                link: "https://www.tesla.com/fleet"
            },
            {
                label: "Semi",
                link: "https://www.tesla.com/semi"
            },
            {
                label: "Roadster",
                link: "https://www.tesla.com/roadster"
            }
        ]
    },
    energy: {
        mainItems: [
            {
                label: "Solar Panels",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Energy-Solar-Panels.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/solarpanels"
                    },
                    {
                        label: "Order",
                        link: "https://www.tesla.com/energy/design"
                    }
                ]
            },
            {
                label: "Solar Roof",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Energy-Solar-Roof.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/solarroof"
                    },
                    {
                        label: "Order",
                        link: "https://www.tesla.com/solarroof/design"
                    }
                ]
            },
            {
                label: "Powerwall",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Energy-Powerwall-US.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/powerwall"
                    },
                    {
                        label: "Order",
                        link: "https://www.tesla.com/powerwall/design"
                    }
                ]
            },
            {
                label: "Megapack",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Energy-Megapack.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/megapack"
                    },
                    {
                        label: "Order",
                        link: "https://www.tesla.com/megapack/design"
                    }
                ]
            }
        ],
        sideItems: [
            {
                label: "Schedule a Consultation",
                link: "https://www.tesla.com/solar-virtual-consultations"
            },
            {
                label: "Why Solar",
                link: "https://www.tesla.com/why-solar"
            },
            {
                label: "Incentives",
                link: "https://www.tesla.com/support/energy/powerwall/learn/incentives"
            },
            {
                label: "Support",
                link: "https://www.tesla.com/support/energy"
            },
            {
                label: "Partner with Tesla",
                link: "https://www.tesla.com/support/energy/powerwall/installer-resources/partner-with-tesla"
            },
            {
                label: "Commercial",
                link: "https://www.tesla.com/commercial"
            },
            {
                label: "Utilities",
                link: "https://www.tesla.com/utilities"
            }
        ]
    },
    charging: {
        mainItems: [
            {
                label: "Charging",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Charging-Charging.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/charging"
                    }
                ]
            },
            {
                label: "Home Charging",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Charging-Home-Charging.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/home-charging"
                    },
                    {
                        label: "Shop",
                        link: "https://shop.tesla.com/category/charging#charging.at-home"
                    }
                ]
            },
            {
                label: "Supercharging",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Charging-Supercharging-NA.png",
                links: [
                    {
                        label: "Learn",
                        link: "https://www.tesla.com/supercharger"
                    },
                    {
                        label: "Find",
                        link: "https://www.tesla.com/findus"
                    }
                ]
            }
        ],
        sideItems: [
            {
                label: "Help Me Charge",
                link: "https://www.tesla.com/charge"
            },
            {
                label: "Charging Calculator",
                link: "https://www.tesla.com/charging-calculator"
            },
            {
                label: "Trip Planner",
                link: "https://www.tesla.com/trips"
            },
            {
                label: "Charging with NACS",
                link: "https://www.tesla.com/NACS"
            },
            {
                label: "Supercharger Voting",
                link: "https://www.tesla.com/supercharger-voting/overview"
            },
            {
                label: "Host a Supercharger",
                link: "https://www.tesla.com/host-a-supercharger"
            },
            {
                label: "Commercial Charging",
                link: "https://www.tesla.com/commercial-charging"
            },
            {
                label: "Host Wall Connectors",
                link: "https://www.tesla.com/charging-partners"
            }
        ]
    },
    discover: {
        sections: [
            {
                label: "Resources",
                items: [
                    {
                        label: "Demo Drive",
                        link: "https://www.tesla.com/drive"
                    },
                    {
                        label: "Insurance",
                        link: "https://www.tesla.com/insurance"
                    },
                    {
                        label: "Video Guides",
                        link: "https://www.tesla.com/support/videos"
                    },
                    {
                        label: "Customer Stories",
                        link: "https://www.tesla.com/customer-stories"
                    },
                    {
                        label: "Events",
                        link: "https://www.tesla.com/events"
                    }
                ]
            },
            {
                label: "Location Services",
                items: [
                    {
                        label: "Find Us",
                        link: "https://www.tesla.com/findus"
                    },
                    {
                        label: "Trip Planner",
                        link: "https://www.tesla.com/trips"
                    },
                    {
                        label: "Find a Collision Center",
                        link: "https://www.tesla.com/support/collision-support"
                    },
                    {
                        label: "Find a Certified Installer",
                        link: "https://www.tesla.com/support/certified-installers"
                    }
                ]
            },
            {
                label: "Company",
                items: [
                    {
                        label: "About",
                        link: "https://www.tesla.com/about"
                    },
                    {
                        label: "Careers",
                        link: "https://www.tesla.com/careers"
                    },
                    {
                        label: "Investor Relations",
                        link: "https://ir.tesla.com/"
                    }
                ]
            }
        ]
    },
    shop: {
        mainItems: [
            {
                label: "Charging",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Shop-Charging.png",
                links: [
                    {
                        label: "",
                        link: "https://shop.tesla.com/category/charging"
                    }
                ]
            },
            {
                label: "Vehicle Accessories",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Shop-Vehicle-Accessories.png",
                links: [
                    {
                        label: "",
                        link: "https://shop.tesla.com/category/vehicle-accessories"
                    }
                ]
            },
            {
                label: "Apparel",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Shop-Apparel.png",
                links: [
                    {
                        label: "",
                        link: "https://shop.tesla.com/category/apparel"
                    }
                ]
            },
            {
                label: "Lifestyle",
                imageSrc: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Mega-Menu-Shop-Lifestyle.png",
                links: [
                    {
                        label: "",
                        link: "https://shop.tesla.com/category/lifestyle"
                    }
                ]
            }
        ]
    }
}